module.exports = __webpack_public_path__ + "static/media/home-bg-mobile.938125f1.webp";